import * as React from 'react';
import DialogBase from '../Shared/DialogBase';
import { Box, Button, Stack, TextField } from '@mui/material';
import { useApi } from '../Api/useApi';
import { ResetPasswordRequest, UsersRycApiClient } from '../Api/ApiServer';
import InfoDialog from '../Shared/InfoDialog';

export interface IResetPasswordSceneProps {
    open: boolean;
    onClose: () => void;
}

export default function ResetPasswordScene(props: IResetPasswordSceneProps) {
    const { open, onClose } = props;
    const [email, setEmail] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [infoText, setInfoText] = React.useState<string>();
    const { unauthorizedApi } = useApi(UsersRycApiClient);

    React.useEffect(() => {
        setEmail('');
    }, [open]);

    const resetPassword = React.useCallback(async () => {
        setLoading(true);
        let res = await unauthorizedApi.resetPassword(new ResetPasswordRequest({ email: email }));
        setLoading(false);
        if (res?.ok) {
            setInfoText('Email s instrukcemi byl odeslán na zadanou adresu.');
        } else {
            setInfoText('Něco se pokazilo. Zkuste to prosím znovu. Pokud problém přetrvává, kontaktujte podporu.');
        }
    }, [unauthorizedApi, email, setLoading]);
    return (
        <DialogBase showCloseButton title='Reset hesla'minWidth={380}
            dialogActions={<Box m={1} justifyContent='center' display={'flex'} width='100%'>
                <Button variant='outlined' onClick={resetPassword} disabled={loading}>Resetovat</Button>
            </Box>}
            open={open} onClose={onClose}>
            <Box>
                <Stack spacing={2} p={2}>
                    <TextField
                        value={email}                        
                        onChange={(e) => setEmail(e.target.value)}
                        label='Email'
                        variant='outlined'
                        fullWidth
                        type='email'
                        disabled={loading}
                    />                    
                </Stack>
            </Box>
            <InfoDialog open={infoText !== undefined} onClose={() => setInfoText(undefined)} title='Reset hesla' text={infoText ?? ''} />
        </DialogBase>
    );
}
